export const SUPPORT_LINK = 'https://t.me/IIIWallet_support';
export const AML_SUPPORT_LINK =
  'https://hglobal.enterprise.slack.com/archives/C09PLPZ4Q3Y';
